import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IFontSizeAutoAdjustBehavior } from "../../../../documaker/domain/format/objects";

export interface IFontSizeAutoAdjustBehaviorPropertyEditable {
  fontSizeAutoAdjustBehavior(): IPropertyEditable<IFontSizeAutoAdjustBehavior>;
}

export function instanceOfIFontSizeAutoAdjustBehaviorPropertyEditable(instance: any): instance is IFontSizeAutoAdjustBehaviorPropertyEditable {
  return instance
      && instance.fontSizeAutoAdjustBehavior
      && instanceOfIPropertyEditable<IFontSizeAutoAdjustBehavior>(instance.fontSizeAutoAdjustBehavior());
}
